import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IActivity } from "../activityModel";

export const getAllActivities = createAsyncThunk(
  "Activity/FindAllActivity",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Activity/FindAllActivity`,
        {
          ActivityName: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching activities:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createActivity = createAsyncThunk(
  "Activity/InsertActivity",
  async (ActivityData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Activity/InsertActivity`,
        ActivityData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating activity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateActivity = createAsyncThunk(
  "Activity/UpdateActivity",
  async (ActivityData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Activity/UpdateActivity`,
        ActivityData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating activity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteActivity = createAsyncThunk(
  "Activity/DeleteActivity",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Activity/DeleteActivity`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting activity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getActivityByID = createAsyncThunk(
  "Activity/FindByIDActivity",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Activity/FindByIDActivity`,
        { ID: ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        ActivityName: result.ActivityName,
        ActivityCode: result.ActivityCode,
        IsActive: result.IsActive ? 1 : 2,
      } as IActivity;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching activity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveActivities = createAsyncThunk(
  "Activity/FindAllActiveActivity",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Activity/FindAllActiveActivity`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching activities:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const activityActiveInactive = createAsyncThunk(
  "Activity/ActiveInActiveActivity",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Activity/ActiveInActiveActivity`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive activity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
